
const getSession = (key)=>{
  return JSON.parse(sessionStorage.getItem(key))
};

const setSession = (key,value)=>{
  return sessionStorage.setItem(key,value)
};

const removeSession = (key)=>{
  return sessionStorage.removeItem(key)
};

export { getSession, setSession ,removeSession}



// WEBPACK FOOTER //
// ./src/assets/commonjs/local.js